module.exports = __webpack_public_path__ + "img/0Q3C6212_WoodMatted_MockedUp.5920b319.jpg";